<template>
  <div class="details">
    <div class="card br-2">
      <div class="p-10">
        <div v-if="engagementContentDetails">
          <h6 class="fw-bold">LEARN</h6>
          <div class="expand-collapse-container">
            <a href="" class="col-1 p-0 make-link" @click.prevent="expandAll()">Expand all</a>
            <span class="link_style"></span>
            <a href="" class="col-1 p-0 make-link" @click.prevent="collapseAll()">Collapse all</a>
          </div>
          <div class="pt-8" v-if="engagementContentDetails.sections">
            <div>
              <i class="fa fa-plus-circle pr-6" v-if="!engagementContent" @click.prevent="engagementContent = true"></i>
              <i class="fa fa-minus-circle pr-6" v-if="engagementContent" @click.prevent="engagementContent = false"></i>
              Content
            </div>
            <div v-if="engagementContent">
              <div class="card inner-card br-2">
                <div class="pt-10" v-for="(section, index) in engagementContentDetails.sections" :key="index">
                  <b-row class="content"> Screen {{ index + 1 }} </b-row>
                  <b-row class="header">
                    {{ section.sectionTitle }}
                  </b-row>
                  <b-row class="content">
                    <span v-html="section.sectionHtmlDetails"></span>
                  </b-row>
                  <b-row class="pb-6">
                    <img class="content-img" v-if="section.sectionBase64" :src="`data:image/png;base64,${section.sectionBase64}`" alt="section-image" />
                  </b-row>
                </div>
              </div>
            </div>
          </div>
          <div class="pt-8 pb-10" v-if="engagementContentDetails.feedback">
            <div>
              <i class="fa fa-plus-circle pr-6" v-if="!expandFeedback" @click.prevent="expandFeedback = true"></i>
              <i class="fa fa-minus-circle pr-6" v-if="expandFeedback" @click.prevent="expandFeedback = false"></i>
              Participant feedback
            </div>
            <div v-if="expandFeedback">
              <div class="card inner-card br-2 pt-10">
                <b-row class="header">
                  {{ engagementContentDetails.feedback.title }}
                </b-row>
                <b-row class="content">
                  {{ engagementContentDetails.feedback.summary }}
                </b-row>
                <b-row class="pb-15">
                  <!-- <img class="content-img" :src="engagementContentDetails.feedback.icon" alt="" /> -->
                  <img class="content-img" v-if="engagementContentDetails.feedback.iconBase64" :src="`data:image/png;base64,${engagementContentDetails.feedback.iconBase64}`" alt="" />
                </b-row>
                <div class="pb-10" v-for="(question, index) in engagementContentDetails.feedback.quiz" :key="index">
                  <b-row class="content"> Question {{ index + 1 }} </b-row>
                  <b-row class="header pb-5">
                    {{ question.body }}
                  </b-row>
                  <div v-if="question.type === 'text'">
                    <input type="text" class="input-text readonly" placeholder="" readonly />
                    <label class="fw-normal display-block" v-if="question.limit">
                      <span class="position_relative fs-12">Text limit: {{ question.limit }}</span>
                    </label>
                  </div>
                  <div v-if="question.type === 'numberScale'">
                    <vue-slider
                      v-if="question.direction.toLowerCase() === 'horizontal'"
                      ref="slider"
                      :value="question.minValue"
                      :piecewise="true"
                      direction="horizontal"
                      class="horizontal-vue-slider pl-20 pt-35"
                      :min="question.minValue"
                      :max="question.maxValue"
                      :disabled="true"
                      :piecewiseLabel="true"
                      :piecewiseStyle="piecewiseStyle"
                      :piecewiseActiveStyle="piecewiseActiveStyle"
                      :labelActiveStyle="labelActiveStyle"
                    ></vue-slider>
                    <vue-slider
                      v-if="question.direction.toLowerCase() === 'vertical'"
                      ref="slider"
                      :value="question.minValue"
                      :piecewise="true"
                      direction="vertical"
                      class="vertical-vue-slider pl-20"
                      width="2"
                      :min="question.minValue"
                      :max="question.maxValue"
                      :disabled="true"
                      :piecewiseLabel="true"
                      :piecewiseStyle="piecewiseStyle"
                      :piecewiseActiveStyle="piecewiseActiveStyle"
                      :labelActiveStyle="labelActiveStyle"
                    ></vue-slider>
                  </div>
                  <div v-if="question.type === 'customScale'">
                    <vue-slider
                      v-if="question.direction.toLowerCase() === 'horizontal'"
                      ref="slider"
                      :value="1"
                      :piecewise="true"
                      direction="horizontal"
                      class="horizontal-vue-slider pl-20 pt-35"
                      :min="parseInt(question.labels[0])"
                      :max="question.labels[question.labels.length]"
                      :disabled="true"
                      :piecewiseLabel="true"
                      :piecewiseStyle="piecewiseStyle"
                      :data="question.labels"
                      :piecewiseActiveStyle="piecewiseActiveStyle"
                      :labelActiveStyle="labelActiveStyle"
                    ></vue-slider>
                    <vue-slider
                      v-if="question.direction.toLowerCase() === 'vertical'"
                      ref="slider"
                      :value="1"
                      :piecewise="true"
                      direction="vertical"
                      class="vertical-vue-slider pl-20"
                      width="2"
                      :min="parseInt(question.labels[0])"
                      :max="question.labels[question.labels.length]"
                      :disabled="true"
                      :piecewiseLabel="true"
                      :piecewiseStyle="piecewiseStyle"
                      :data="question.labels"
                      :piecewiseActiveStyle="piecewiseActiveStyle"
                      :labelActiveStyle="labelActiveStyle"
                    ></vue-slider>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSlider from "vue-slider-component";
import ImageToBase64 from "image-to-base64";
/* 
IMPORTANT
Please make sure that this file and enagement-content.vue which is inside the study-details folder are in sync so that the PDF is updated with the most recent code.
 */
export default {
  name: "engagement-content-details",
  data() {
    return {
      engagementContent: false,
      expandFeedback: false,
      labelActiveStyle: {
        color: "#3498db"
      },
      piecewiseStyle: {
        backgroundColor: "#ccc",
        visibility: "visible",
        width: "12px",
        height: "12px"
      }
    };
  },
  components: {
    vueSlider: VueSlider
  },
  props: {
    engagementContentDetails: {
      type: Object,
      default: () => {}
    },
    exportPdfClicked: {
      type: Boolean
    }
  },
  methods: {
    expandAll() {
      this.engagementContent = true;
      this.expandFeedback = true;
    },
    collapseAll() {
      this.engagementContent = false;
      this.expandFeedback = false;
    },
    imageToBase64(image, parent) {
      ImageToBase64(image) // Image URL
        .then(response => {
          if (parent.sectionIcon) {
            parent.sectionBase64 = response;
          }
          if (parent.icon) {
            parent.iconBase64 = response;
          }
          this.$forceUpdate();
        });
    },
    replaceIframeWithVideoLinks(strOld) {
      let str = strOld;
      const originalString = str;
      const iframes = [];
      const indexes = [...str.matchAll(new RegExp("<iframe", "gi"))].map(a => a.index);
      for (let i = 0; i < indexes.length; i++) {
        iframes[i] = originalString.substring(indexes[i], originalString.indexOf("</iframe", indexes[i]) + 9);
        const videoLink = iframes[i].substring(iframes[i].indexOf("src=") + 5, iframes[i].indexOf('\\"', iframes[i].indexOf("src=") + 5));
        if (videoLink.indexOf("threadresearch") > -1) {
          str = str.replace(iframes[i], "<div><b>There is a link available. Please visit study details page.</b></div>");
        } else {
          str = str.replace(iframes[i], '<div><a href="' + videoLink + '">' + videoLink + "</a></div>");
        }
      }
      return str;
    }
  },
  watch: {
    exportPdfClicked: function(newVal) {
      if (newVal) {
        this.expandAll();
        if (this.engagementContent) {
          if (this.engagementContentDetails.sections) {
            this.engagementContentDetails.sections.forEach(section => {
              this.imageToBase64(section.sectionIcon, section);
              section.sectionHtmlDetails = this.replaceIframeWithVideoLinks(section.sectionHtmlDetails);
            });
          }
          if (this.engagementContentDetails.feedback) {
            this.imageToBase64(this.engagementContentDetails.feedback.icon, this.engagementContentDetails.feedback);
          }
        }
      }
    }
  }
};
</script>

<style scoped>
.link_style {
  border-right: 1px solid #959fa4;
  margin: 0px 5px 0px 2px !important;
}
.inner-card {
  border: none;
  margin: 5px 20px;
  border-radius: 3px !important;
  background-color: #d3dfe4;
}
.content {
  font-size: 12px;
  color: #666669;
}
.header {
  font-size: 12px;
  font-weight: bold;
  color: #666669;
}
p {
  margin-top: 0;
  margin-bottom: 0 !important;
}
.sub-header {
  opacity: 0.7;
  font-size: 12px;
  color: #666669;
}
.radio-style {
  position: relative;
  top: 2px;
}
.doc-style {
  color: #4c8ce4;
}
.content-img {
  width: auto;
  height: 100%;
  max-height: 80px;
}

/deep/ img {
  padding-right: 10px;
  padding-left: 10px;
  width: auto !important;
  height: 100% !important;
  max-width: 90px !important;
  max-height: 90px !important;
  padding-top: 2px !important;
}

.input-text {
  width: 80%;
  border-radius: 2px;
  outline: none;
  border: 1px solid #ccc;
  height: 30px;
  text-indent: 10px;
}

.vertical-vue-slider {
  height: 200px !important;
  width: 4px;
  padding: 11px;
  margin-left: 30px;
}

.horizontal-vue-slider {
  height: 8px;
  width: 80% !important;
  padding: 10px;
}
.make-link {
  color: #1e8fe1 !important;
}
</style>
